import { useState, useContext, useEffect } from "react"
import { useParams, NavLink } from "react-router-dom"
import { ticketViewUrl, raiseRequestAttachments } from "../../Config/config"
import ProfileHighlight from "./RequestsDetailComponents/Comments"
import { routeNames } from "../../routeSegments"
import axios from "axios"
import Loader from "../../Components/Loader"
import moment from "moment"
import { UserContext } from "../../Contexts/UserContext"
import downloadIcon from "../../images/ReportsImages/download.png"
import { clickableParagraphHavingUrlsAndLinebreak } from "../../Components/CommonUtils"

const CompanyDetail = (props) => {
  const [isActive, setIsActive] = useState(1)
  const [isLoading, setisLoading] = useState(false)
  const [ticketDetails, setTicketDetails] = useState()
  const [attachments, setAttachments] = useState([])
  const [attachmentsLoading, setAttachmentsLoading] = useState(false)
  const [attachmentsData, setAttachmentsData] = useState([])
  const { requestId } = useParams()
  const { getToken } = useContext(UserContext)

  useEffect(() => {
    setisLoading(true)
    axios
      .post(
        ticketViewUrl,
        {
          ticket_id: requestId,
        },
        {
          headers: {
            Authorization: getToken(),
          },
        },
      )
      .then((response) => {
        setisLoading(false)
        if (response.status === 200) {
          setTicketDetails(response.data?.comments?.at(0))
        }
      })
  }, [requestId])



  useEffect(() => {
    if (ticketDetails?.ticket_id) {
      setAttachmentsLoading(true)
      fetch(`${raiseRequestAttachments}${ticketDetails.ticket_id}/`, {
        method: "POST",
        headers: {
          Authorization: getToken(),
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setAttachmentsData(data.s3_links)
          setAttachmentsLoading(false)
        })
        .catch((error) => {
          console.error("Error fetching attachments:", error)
          setAttachmentsLoading(false)
        })
    }
  }, [ticketDetails, getToken])

  const getStatusColor = (status) => {
    if (!status) return "bg-[#fef200] text-gray-700"; // Yellow for Open (null status)
  
    switch (status.toLowerCase()) {
      case "open":
        return "bg-[#fef200] text-gray-700"; // Yellow for Open
      case "re-opened":
        return "bg-red-500"; // Red for Reopened
      case "work-in-progress":
        return "bg-orange-500"; // Orange for Work-in-progress
      case "closed":
        return "bg-green-500"; // Green for Closed
      case "fail":
        return "bg-gray-700"; // Dark Gray for Automation Failure
      default:
        return "bg-[#fef200] text-gray-700"; // Default is Yellow (Open)
    }
  };
  
  // Function to get the display status with icons
  const getDisplayStatus = (status) => {
    const statusMap = {
      open: "Open",
      closed: "Closed",
      "work-in-progress": "Work In Progress",
      "re-opened": "Re-opened",
      // fail: "❌ Automation Failure",
    };
  
    return status ? statusMap[status.toLowerCase()] || "Open" : "Open";
  };
  return (
    <>
      <div className="bg-white">
        {/* Breadcrumb */}
        <nav className="flex p-2 px-6 border-b border-gray-200" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-1">
            <li className="flex items-center">
              <NavLink className="text-[13px] font-normal text-gray-600" to={routeNames.pe_companies_pe_vc_investments}>
                Home
              </NavLink>
            </li>
            <li className="flex items-center">
              <span className="text-[13px] text-gray-600 mx-1">/</span>
              <NavLink className="text-[13px] font-normal text-gray-600" to="/requests">
                Requests
              </NavLink>
            </li>
            <li>
              <span className="text-[13px] text-gray-600 mx-1">/</span>
              <span className="text-[13px] font-normal text-gray-600" aria-current="page">
                #{ticketDetails?.ticket_id}
              </span>
            </li>
          </ol>
        </nav>

        {/* Main content */}
        {isLoading ? (
          <div className="h-48 flex items-center justify-center">
            <Loader />
          </div>
        ) : (
          <div className="px-6 py-4">
            {/* Title and info */}
            <div className="flex items-center mb-2">
              <h1 className="text-xl font-semibold text-gray-800 mr-3">{ticketDetails?.subject}</h1>
              <div className={`${getStatusColor(ticketDetails?.status)} text-white text-[13px] font-medium px-2  rounded`}>
                {getDisplayStatus(ticketDetails?.status)}
              </div>
            </div>

            <div className="flex items-center mb-4">
              <div className="border-[#bc8b20] border text-[#bc8b20] text-[13px] font-medium px-2 rounded mr-4">
                {ticketDetails?.product || "CFS"}
              </div>
              <span className="text-[13px] text-gray-600">
                <span className="font-semibold">
                  Created Date:
                </span>{" "}
                {moment(ticketDetails?.created_at).format("DD MMM YYYY")},{" "}
                <span className="font-semibold">
                  Updated Date:
                </span>{" "}
                {moment(ticketDetails?.updated_at).format("DD MMM YYYY")}
              </span>
              <div className="ml-auto">
                <div className="bg-gray-100 text-gray-700 text-[13px] px-2 py-1 rounded">
                  Ticket ID: #{ticketDetails?.ticket_id}
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="flex space-x-6 items-start py-6">
              {/* Description Box */}
              <div className="w-4/5 flex flex-row gap-8 ">
                <h2 className="text-md font-semibold mb-2">Description</h2>
                <div className="border border-gray-400 rounded p-4 pb-5 bg-white w-full h-[30%]">
                  <p className="text-gray-700 text-sm whitespace-pre-wrap">
                    {clickableParagraphHavingUrlsAndLinebreak(ticketDetails?.description || "-")}
                  </p>
                </div>
              </div>
            </div>


            {/* Tabs */}
            <div className="border-b border-gray-200">
              <div className="flex space-x-6">
                <button
                  className={`py-2 px-1 text-sm font-medium ${isActive === 1 ? "text-[#bc8b20] border-b-2 border-[#bc8b20]" : "text-gray-600"}`}
                  onClick={() => setIsActive(1)}
                >
                  Comments
                </button>
                <button
                  className={`py-2 px-1 text-sm font-medium ${isActive === 2 ? "text-[#bc8b20] border-b-2 border-[#bc8b20]" : "text-gray-600"}`}
                  onClick={() => setIsActive(2)}
                >
                  Attachments
                </button> 
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Comments/Attachments content */}
      <div className="bg-white">
        <div className="px-6 pb-4 ml-4 mr-10">
          {isActive === 1 && (
            <div>
              <ProfileHighlight ticketId={ticketDetails?.ticket_id} author={ticketDetails?.author} />
              {/* <div className="mt-4">
                <textarea
                  className="w-full border border-gray-300 rounded p-2 text-sm"
                  rows="3"
                  placeholder="Type..."
                ></textarea>
                <div className="flex justify-end mt-2">
                  <button className="bg-amber-600 hover:bg-amber-700 text-white font-medium py-2 px-4 rounded text-sm">
                    Post Comments
                  </button>
                </div>
              </div> */}
            </div>
          )}

          {isActive === 2 && (
            <div className="py-4">
              {attachmentsLoading ? (
                <Loader />
              ) : (
                <div>
                  {attachmentsData.map((link, index) => (
                    <a
                      key={index}
                      className="flex items-center py-2 text-sm text-gray-700 hover:text-blue-600"
                      href={link}
                      rel="noreferrer"
                    >
                      <img
                        alt=""
                        src={downloadIcon || "/placeholder.svg"}
                        className="h-4 w-4 mr-2"
                        aria-hidden="true"
                      />
                      {link.substring(link.lastIndexOf("/") + 1)}
                    </a>
                  ))}
                  {attachmentsData.length === 0 && <p className="text-gray-500">No attachments found</p>}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default CompanyDetail